import { FormControl, FormGroup } from '@angular/forms';
import { TransformToFormControl } from './common';
import { OrganizationMember } from './organization-member';

export type Client = {
  id: Nullable<number>;
  name: Nullable<string>;
  inn: Nullable<string>;
  addressesWithCoordinatesJson: AddressWithCoordinates[];
  discount: Nullable<number>;
  uniqueKey: Nullable<string>;
  publicAccess: Nullable<boolean>;
  storageKeepersJson: StorageKeeper[];
  tgBotChatId: Nullable<number>;
  members: OrganizationMember[];
  comment: Nullable<string>;
  workCondition: ClientWorkCondition;
};

export type ClientWorkCondition = {
  swiftSum: Nullable<number>;
  providerSum: Nullable<number>;
  documentPlace: Nullable<DocumentPlace>;
  nomenclaturePlace: Nullable<DocumentPlace>;
  deliveryPaymentType: Nullable<DeliveryPayment>;
  credit: Nullable<boolean>;
};

export type ClientWorkConditionForm =
  TransformToFormControl<ClientWorkCondition>;
export enum DocumentPlace {
  STORAGE = 'STORAGE',
  LOB = 'LOB',
  NONE = 'NONE',
}

export enum DeliveryPayment {
  ZERO_PERCENT = 'ZERO_PERCENT',
  HUNDRED_PERCENT = 'HUNDRED_PERCENT',
  COMB = 'COMB',
}

export type StorageKeeper = {
  name: Nullable<string>;
  phone: Nullable<string>;
};
export type AddressWithCoordinates = {
  address: Nullable<string>;
  latitude: Nullable<string>;
  longitude: Nullable<string>;
};

export type AddressWithCoordinatesForm =
  TransformToFormControl<AddressWithCoordinates>;

export type ClientForm = TransformToFormControl<
  Omit<Client, 'addressesWithCoordinatesJson' | 'workCondition'>
> & {
  addressesWithCoordinatesJson: FormControl<AddressWithCoordinates[]>;
  workCondition: FormGroup<ClientWorkConditionForm>;
};
